import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useI18nDirection = <T extends HTMLElement = HTMLElement>() => {
  const { i18n } = useTranslation();
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.setAttribute('dir', i18n.dir() ?? 'ltr');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return ref;
};
